import { EventHandler, WatcherHandler } from './../types';

import EVENTS from './event';
import PROPERTIES from './property';
import TIMINGS from './timing';

const ALL: Array<EventHandler | WatcherHandler> = [
  ...EVENTS,
  ...PROPERTIES,
  ...TIMINGS,
];

export default ALL;
